import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetModule } from '../widget/widget.module';
import { DefaultDashboardLayoutComponent } from './components/default-dashboard-layout/default-dashboard-layout.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { LayoutHeaderComponent } from './components/layout-header/layout-header.component';
import { CoreModule } from '../core/core.module';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShiftSelectorComponent } from './components/custom-widget/shift-widget/shift-selector/shift-selector.component';
import { ShiftGroupComponent } from './components/custom-widget/shift-widget/shift-group/shift-group.component';
import { SidebarModule } from '../sidebar/sidebar.module';
import { DashboardWidgetBasicComponent } from './components/dashboard-widget-basic/dashboard-widget-basic.component';
import { DashboardWidgetChartComponent } from './components/dashboard-widget-chart/dashboard-widget-chart.component';
import { DashboardWidgetTableComponent } from './components/dashboard-widget-table/dashboard-widget-table.component';
import { LayoutGuardService } from './services/guard/layout-guard.service';
import { Common2Module } from 'projects/common/src/app/app.module';
import { AuthenticationModule } from 'projects/authentication/src/app/app.module';
import { communicationServiceProvider, authenticationServiceProvider } from 'src/app/services/providers';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptorService } from 'projects/communication/src/app/services/interceptors';
import { AuthenticationInterceptorService } from 'projects/authentication/src/app/services/interceptors';
import { MachineStatusByShiftComponent } from './components/custom-widget/machine-status-by-shift/machine-status-by-shift.component';
import { MachineStatusComponent } from './components/custom-widget/machine-status-widget/machine-status/machine-status.component';
import { MachineStatusGroupComponent } from './components/custom-widget/machine-status-widget/machine-status-group/machine-status-group.component';
import { MachineStatusService } from './services/machine-status/machine-status.service';
import { StatusByMachineComponent } from './components/custom-widget/status-by-machine/status-by-machine.component';
import { DrillsByMachineComponent } from './components/custom-widget/drills-by-machine/drills-by-machine.component';
import { StatusFrontGroupComponent } from './components/custom-widget/status-front-widget/status-front-group/status-front-group.component';
import { StatusFrontComponent } from './components/custom-widget/status-front-widget/status-front/status-front.component';
import { FooterModule } from '../footer/footer.module';
import { TooltipModule } from 'ng2-tooltip-directive';
import { GeneralStatusSummaryComponent } from './components/custom-widget/general-status-summary-widget/general-status-summary/general-status-summary.component';
import { GeneralStatusSummaryGroupComponent } from './components/custom-widget/general-status-summary-widget/general-status-summary-group/general-status-summary-group.component';
import { ProductionByHourComponent } from './components/custom-widget/production-by-hour/production-by-hour.component';
import { DatePresentationPipe } from '../core/pipes/date-presentation.pipe';
import { ProductionByFrontComponent } from './components/custom-widget/production-by-front/production-by-front.component';
import { DateTimePresentationPipe } from '../core/pipes/date-time-presentation.pipe';
import { ChangeStatusModalComponent } from './components/custom-widget/machine-status-widget/change-status-modal/change-status-modal.component';
import { OperationalDisciplineComponent } from './components/custom-widget/operational-discipline/operational-discipline.component';
import { StatusByMachineGroupComponent } from './components/custom-widget/status-by-machine-group-widget/status-by-machine-group/status-by-machine-group.component';
import { StatusModalComponent } from './components/custom-widget/status-by-machine-group-widget/status-modal/status-modal.component';
import { TrainMinuteByMinuteComponent } from './components/custom-widget/train-minute-by-minute/train-minute-by-minute.component';
import { StatusByMachineTableComponent } from './components/custom-widget/status-by-machine-table/status-by-machine-table.component';
import { LoopsByTrainComponent } from './components/custom-widget/loops-by-train/loops-by-train.component';
import { TimePresentationPipe } from '../core/pipes/time-presentation.pipe';
import { FullTimePresentationPipe } from '../core/pipes/full-time-presentation.pipe';
import { LoopsByServiceTrainComponent } from './components/custom-widget/loops-by-service-train/loops-by-service-train.component';
import { TransitLoopsBznComponent } from './components/custom-widget/transit-loops-bzn/transit-loops-bzn.component';
import { ProductionByOperatorComponent } from './components/custom-widget/production-by-operator/production-by-operator.component';
import { StatusModalShellComponent } from './components/custom-widget/machine-status-widget/status-modal-shell/status-modal-shell.component';
import { ChangeStatusComponent } from './components/custom-widget/machine-status-widget/change-status/change-status.component';
import { SummaryTeamComponent } from './components/custom-widget/machine-status-widget/summary-team/summary-team.component';
import { ChangeParkComponent } from './components/custom-widget/machine-status-widget/change-park/change-park.component';
import { TeamFeatureComponent } from './components/custom-widget/machine-status-widget/team-feature/team-feature.component';
import { ProductionByStreetChartComponent } from './components/custom-widget/production-by-street/production-by-street-chart/production-by-street-chart.component';
import { ProductionByStreetModalComponent } from './components/custom-widget/production-by-street/production-by-street-modal/production-by-street-modal.component';
import { TotalExtractionComponent } from './components/custom-widget/total-extraction/total-extraction.component';
import { TotalExtractionService } from './services/total-extraction/total-extraction.service';
import { FirstLastLoopModalComponent } from './components/custom-widget/total-extraction/first-last-loop-modal/first-last-loop-modal.component';
import { FirstLastLoopDetailTableComponent } from './components/custom-widget/total-extraction/first-last-loop-detail-table/first-last-loop-detail-table.component';
import { ProductionEveryThirtyMinutesComponent } from './components/custom-widget/production-every-thirty-minutes/production-every-thirty-minutes.component';
import { ClockComponent } from './components/custom-widget/production-every-thirty-minutes/clock/clock.component';
import { ProductionByStreetService } from './services/production-by-street/production-by-street.service';
import { ProdByExtractionPointChartComponent } from './components/custom-widget/production-by-street/prod-by-extraction-point-chart/prod-by-extraction-point-chart.component';
import { ProdByExtractionPointTableComponent } from './components/custom-widget/production-by-street/prod-by-extraction-point-table/prod-by-extraction-point-table.component';
import { ProductionByMachineComponent } from './components/custom-widget/production-by-machine/production-by-machine.component';
import { ProductionModalComponent } from './components/custom-widget/common/production-modal/production-modal.component';
import { SummaryProductionComponent } from './components/custom-widget/common/production-modal/summary-production/summary-production.component';
import { ShiftLoopsProductionComponent } from './components/custom-widget/common/production-modal/shift-loops-production/shift-loops-production.component';
import { StatisticsProductionComponent } from './components/custom-widget/common/production-modal/statistics-production/statistics-production.component';
import { MinuteByMinuteComponent } from './components/custom-widget/minute-by-minute/minute-by-minute.component';
import { StatusParkComponent } from './components/custom-widget/status-park/status-park.component';
import { DetailDumpPointComponent } from './components/custom-widget/detail-dump-point/detail-dump-point.component';
import { TotalChargeComponent } from './components/custom-widget/total-charge/total-charge.component';
import { TotalChargeModalComponent } from './components/custom-widget/total-charge/total-charge-modal/total-charge-modal.component';
import { ProductionByTypetruckDumpPointComponent } from './components/custom-widget/production-by-typetruck-dump-point/production-by-typetruck-dump-point.component';
import { ProdByTypetruckModalComponent } from './components/custom-widget/production-by-typetruck-dump-point/prod-by-typetruck-modal/prod-by-typetruck-modal.component';
import { ProdByTypetruckChartComponent } from './components/custom-widget/production-by-typetruck-dump-point/prod-by-typetruck-chart/prod-by-typetruck-chart.component';
import { TransferScoopComponent } from './components/custom-widget/transfer-scoop/transfer-scoop.component';
import { ProductionTonsByHourComponent } from './components/custom-widget/production-tons-by-hour/production-tons-by-hour.component';
import { GeneralDrillingComponent } from './components/custom-widget/general-drilling/general-drilling.component';
import { DrillActivityTypeComponent } from './components/custom-widget/drill-activity-type/drill-activity-type.component';
import { ProdVsPlanChartComponent } from './components/custom-widget/production-vs-plan/prod-vs-plan-chart/prod-vs-plan-chart.component';
import { ProdVsPlanModalComponent } from './components/custom-widget/production-vs-plan/prod-vs-plan-modal/prod-vs-plan-modal.component';
import { ProdVsPlanModalChartComponent } from './components/custom-widget/production-vs-plan/prod-vs-plan-modal-chart/prod-vs-plan-modal-chart.component';
import { ProductionByChimneyComponent } from './components/custom-widget/production-by-chimney/production-by-chimney.component';
import { ProductionByChimneyModalComponent } from './components/custom-widget/production-by-chimney/production-by-chimney-modal/production-by-chimney-modal.component';
import { ChangeUbicationComponent } from './components/custom-widget/machine-status-widget/change-ubication/change-ubication.component';
import { TonsByOriginComponent } from './components/custom-widget/tons-by-origin/tons-by-origin.component';
import { LoopsByOriginComponent } from './components/custom-widget/loops-by-origin/loops-by-origin.component';

import { ProductionHourByModelTruckComponent } from './components/custom-widget/production-hour-by-model-truck/production-hour-by-model-truck.component';
import { ProductionByTruckHourDayComponent } from './components/custom-widget/production-by-truck-hour-day/production-by-truck-hour-day.component';
import { ProductionByModelTruckDumpPointComponent } from './components/custom-widget/production-by-model-truck-dump-point/production-by-model-truck-dump-point.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { LayoutModule } from '../layout/layout.module';
import { DelayTimeTruckEmbeddedComponent } from './components/custom-widget/delay-time-truck-embedded/delay-time-truck-embedded.component';
import { MachineStatusTableComponent } from './components/custom-widget/machine-status-widget/machine-status-table/machine-status-table.component';
import { ProductionByTruckAndTolvaComponent } from './components/custom-widget/production-by-truck-and-tolva/production-by-truck-and-tolva.component';
import { TotalExtractionTableComponent } from './components/custom-widget/total-extraction/total-extraction-table/total-extraction-table.component';
import { StatusParkTableComponent } from './components/custom-widget/status-park/status-park-table/status-park-table.component';
import { ProductionByStreetTableComponent } from './components/custom-widget/production-by-street/production-by-street-table/production-by-street-table.component';

@NgModule({
  declarations: [
    DefaultDashboardLayoutComponent,
    LayoutHeaderComponent,
    ShiftSelectorComponent,
    ShiftGroupComponent,
    DashboardWidgetBasicComponent,
    DashboardWidgetChartComponent,
    DashboardWidgetTableComponent,
    MachineStatusByShiftComponent,
    MachineStatusComponent,
    MachineStatusGroupComponent,
    StatusByMachineComponent,
    DrillsByMachineComponent,
    StatusFrontGroupComponent,
    StatusFrontComponent,
    GeneralStatusSummaryComponent,
    GeneralStatusSummaryGroupComponent,
    ProductionByHourComponent,
    ProductionByFrontComponent,
    ChangeStatusModalComponent,
    OperationalDisciplineComponent,
    StatusByMachineGroupComponent,
    StatusModalComponent,
    TrainMinuteByMinuteComponent,
    StatusByMachineTableComponent,
    LoopsByTrainComponent,
    LoopsByServiceTrainComponent,
    TransitLoopsBznComponent,
    ProductionByOperatorComponent,
    ProductionModalComponent,
    SummaryProductionComponent,
    ShiftLoopsProductionComponent,
    StatisticsProductionComponent,
    StatusModalShellComponent,
    ChangeStatusComponent,
    SummaryTeamComponent,
    ChangeParkComponent,
    TeamFeatureComponent,
    ProductionByStreetChartComponent,
    ProductionByStreetModalComponent,
    TotalExtractionComponent,
    FirstLastLoopModalComponent,
    FirstLastLoopDetailTableComponent,
    ProductionEveryThirtyMinutesComponent,
    ClockComponent,
    ProdByExtractionPointChartComponent,
    ProdByExtractionPointTableComponent,
    ProductionByMachineComponent,
    MinuteByMinuteComponent,
    StatusParkComponent,
    DetailDumpPointComponent,
    TotalChargeComponent,
    TotalChargeModalComponent,
    ProductionByTypetruckDumpPointComponent,
    ProdByTypetruckModalComponent,
    ProdByTypetruckChartComponent,
    TransferScoopComponent,
    ProductionTonsByHourComponent,
    GeneralDrillingComponent,
    DrillActivityTypeComponent,
    ProdVsPlanChartComponent,
    ProdVsPlanModalComponent,
    ProdVsPlanModalChartComponent,
    ProductionByChimneyComponent,
    ProductionByChimneyModalComponent,
    ChangeUbicationComponent,
    TonsByOriginComponent,
    LoopsByOriginComponent,
    ProductionHourByModelTruckComponent,
    ProductionByTruckHourDayComponent,
    ProductionByModelTruckDumpPointComponent,
    DelayTimeTruckEmbeddedComponent,
    MachineStatusTableComponent,
    ProductionByTruckAndTolvaComponent,
    TotalExtractionTableComponent,
    StatusParkTableComponent,
    ProductionByStreetTableComponent,
  ],
  providers: [
    MachineStatusService,
    LayoutGuardService,
    TotalExtractionService,
    ProductionByStreetService,
    communicationServiceProvider,
    authenticationServiceProvider,
    DatePresentationPipe,
    DateTimePresentationPipe,
    TimePresentationPipe,
    FullTimePresentationPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    WidgetModule,
    DashboardRoutingModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    FooterModule,
    SidebarModule,
    Common2Module.forRoot(),
    AuthenticationModule.forRoot(),
    TooltipModule,
    BrowserAnimationsModule,
    MatTabsModule,
    LayoutModule,
  ],
  exports: [DefaultDashboardLayoutComponent],
})
export class DashboardModule {}
